
















import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { GEnum } from '@/constants/enum.defination';
import { FindingsProposalDescription } from '@/models/student/student-findings-proposals';

@Component({
  name: 'GStudentRecordFindingsProposalsTable',
  components: {},
  computed: {},
  methods: {},
})
export default class GStudentRecordFindingsProposalsTable extends mixins(GPageBase) {
  findingsProposalsListColumn: object[] = [];

  @Prop() competencies: FindingsProposalDescription[];

  async mounted() {
    this.createColumn();
  }

  get competenciesRankingTop3(): FindingsProposalDescription[] {
    return this.competencies.filter(competency => !!competency.competencyScore).slice(0, 3);
  }

  createColumn(): void {
    this.findingsProposalsListColumn = [this.columnOrder, this.columnCompetencyName, this.columnFindingsProposal1, this.columnFindingsProposal2, this.columnFindingsProposal3];
  }

  get columnOrder(): any {
    return {
      title: this.$t('ORDER').toString(),
      slot: 'order',
      align: 'center',
      className: 'background-color-blue-column position-relative',
    };
  }

  get columnCompetencyName(): any {
    return {
      title: this.$t('COMPETENCY').toString(),
      key: 'competencyName',
      width: 180,
      align: 'center',
      className: 'background-color-blue-column position-relative',
      render: (h: any, params: any) => {
        const { competencyName, isInitiative, isCollaboration } = params.row;
        if (isInitiative) {
          return h('div', {}, [h('div', {}, competencyName), h('div', { class: 'optional-item' }, this.$t('COMPETENCY_GROUPING_I').toString())]);
        } else if (isCollaboration) {
          return h('div', {}, [h('div', {}, competencyName), h('div', { class: 'optional-item' }, this.$t('COMPETENCY_GROUPING_C').toString())]);
        } else {
          return h('span', {}, competencyName);
        }
      },
    };
  }

  get columnFindingsProposal1(): any {
    return {
      title: `${this.$t('FINDINGS_PROPOSAL').toString()}1`,
      key: 'description1',
      width: 320,
      align: 'center',
      className: 'position-relative',
      render: (h: any, params: any) => {
        const { description1 } = params.row;
        return this.createRenderFunctionForFindingsProposal(h, params, description1);
      },
    };
  }

  get columnFindingsProposal2(): any {
    return {
      title: `${this.$t('FINDINGS_PROPOSAL').toString()}2`,
      key: 'description2',
      width: 320,
      align: 'center',
      className: 'position-relative',
      render: (h: any, params: any) => {
        const { description2 } = params.row;
        return this.createRenderFunctionForFindingsProposal(h, params, description2);
      },
    };
  }

  get columnFindingsProposal3(): any {
    return {
      title: `${this.$t('FINDINGS_PROPOSAL').toString()}3`,
      key: 'description3',
      width: 320,
      align: 'center',
      className: 'position-relative',
      render: (h: any, params: any) => {
        const { description3 } = params.row;
        return this.createRenderFunctionForFindingsProposal(h, params, description3);
      },
    };
  }

  createRenderFunctionForFindingsProposal(h: any, params: any, description: string) {
    return h('div', {}, [
      h('div', {}, description),
      h('div', { class: 'optional-item' }, [
        h('a', {}, [
          h('Icon', {
            props: {
              type: 'ios-clipboard',
              size: 20,
            },
            on: {
              click: () => {
                this.$copyText(description);
                this.showMessage(GEnum.MessageType.Info, this.$t('COPY_FINDINGS_PROPOSAL').toString());
              },
            },
          }),
        ]),
      ]),
    ]);
  }
}
